(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hob-scratch-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialogs = document.querySelectorAll(
      '.hob-scratch:not([data-ready])'
    );

    dialogs.forEach((dialog) => {
      dialog.dataset.ready = 'true';

      const storageKey = `hob-scratch-${dialog.id}`;
      const canvas = dialog.querySelector('[data-scratch-canvas]');
      const hint = dialog.querySelector('[data-scratch-hint]');
      const revealButton = dialog.querySelector('[data-scratch-reveal]');
      const gate = dialog.querySelector('[data-scratch-gate]');
      const form = dialog.querySelector('[data-scratch-form]');
      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"]');
      const error = dialog.querySelector('[data-scratch-error]');
      const result = dialog.querySelector('[data-scratch-result]');
      const codeElement = dialog.querySelector('[data-scratch-code]');
      const copyButton = dialog.querySelector('[data-scratch-copy]');
      const shopLink = dialog.querySelector('[data-scratch-shop]');
      const closeButton = dialog.querySelector('.hob-scratch__close');

      const publicKey = dialog.dataset.klaviyoKey;
      const listId = dialog.dataset.klaviyoList;
      const discountCode = dialog.dataset.discountCode;
      const shopPath = dialog.dataset.shopPath;
      const reward = dialog.dataset.reward;

      let drawing = false;
      let scratched = false;
      let claimed = false;
      let lastPoint = null;

      const readState = () => {
        try {
          return JSON.parse(
            localStorage.getItem(storageKey) || '{}'
          );
        } catch (_error) {
          return {};
        }
      };

      const writeState = (state) => {
        try {
          localStorage.setItem(
            storageKey,
            JSON.stringify(state)
          );
        } catch (_error) {
          return;
        }
      };

      const isFresh = (value, days) => {
        if (!value) return false;

        return Date.now() - Number(value) < days * 86400000;
      };

      const shouldOpen = () => {
        if (dialog.dataset.designMode === 'true') return true;

        const state = readState();

        if (
          isFresh(
            state.claimedAt,
            Number(dialog.dataset.claimedDays)
          )
        ) {
          return false;
        }

        if (
          isFresh(
            state.dismissedAt,
            Number(dialog.dataset.dismissDays)
          )
        ) {
          return false;
        }

        return !window.location.pathname.startsWith('/account');
      };

      const openDialog = () => {
        if (!dialog.open && shouldOpen()) {
          dialog.showModal();
          window.requestAnimationFrame(paintCanvas);
        }
      };

      const delay = Number(dialog.dataset.delay) || 8000;

      window.setTimeout(
        openDialog,
        dialog.dataset.designMode === 'true' ? 250 : delay
      );

      const exitIntent = (event) => {
        if (event.clientY <= 4 && shouldOpen()) {
          openDialog();
          document.removeEventListener('mouseout', exitIntent);
        }
      };

      if (window.matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseout', exitIntent);
      }

      closeButton.addEventListener('click', () => {
        if (!claimed) {
          writeState({
            ...readState(),
            dismissedAt: Date.now()
          });
        }

        dialog.close();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeButton.click();
        }
      });

      const subscribe = async (email) => {
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties: {
                      'Signup source': 'HOB Scratch Card',
                      'Scratch reward': reward,
                      'Scratch coupon': discountCode
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        };

        const endpoint =
          'https://a.klaviyo.com/client/subscriptions/' +
          `?company_id=${encodeURIComponent(publicKey)}`;

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('subscription_failed');
        }
      };

      const identifyAndTrack = (email) => {
        const profile = {
          email,
          'Signup source': 'HOB Scratch Card',
          'Scratch reward': reward,
          'Scratch coupon': discountCode
        };

        const eventProperties = {
          'Signup Source': 'HOB Scratch Card',
          Reward: reward,
          'Coupon Code': discountCode
        };

        if (
          window.klaviyo &&
          typeof window.klaviyo.identify === 'function'
        ) {
          window.klaviyo.identify(profile);

          window.klaviyo.track(
            'HOB Scratch Card Revealed',
            eventProperties
          );
        } else {
          window._learnq = window._learnq || [];

          window._learnq.push([
            'identify',
            profile
          ]);

          window._learnq.push([
            'track',
            'HOB Scratch Card Revealed',
            eventProperties
          ]);
        }
      };

      function paintCanvas() {
        if (scratched || !dialog.open) return;

        const rect = canvas.getBoundingClientRect();

        if (!rect.width || !rect.height) return;

        const ratio = Math.min(
          window.devicePixelRatio || 1,
          2
        );

        canvas.width = Math.round(rect.width * ratio);
        canvas.height = Math.round(rect.height * ratio);

        const context = canvas.getContext('2d', {
          willReadFrequently: true
        });

        context.setTransform(
          ratio,
          0,
          0,
          ratio,
          0,
          0
        );

        const gradient = context.createLinearGradient(
          0,
          0,
          rect.width,
          rect.height
        );

        gradient.addColorStop(0, '#d6d1c8');
        gradient.addColorStop(0.45, '#f5a623');
        gradient.addColorStop(1, '#b7afa1');

        context.fillStyle = gradient;
        context.fillRect(
          0,
          0,
          rect.width,
          rect.height
        );

        context.fillStyle = '#071f3a';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = '800 17px Arial, sans-serif';

        context.fillText(
          'SCRATCH TO REVEAL',
          rect.width / 2,
          rect.height / 2
        );

        context.globalCompositeOperation = 'destination-out';
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.lineWidth = 34;
      }

      const pointFromEvent = (event) => {
        const rect = canvas.getBoundingClientRect();

        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
      };

      const scratchedEnough = () => {
        const context = canvas.getContext('2d', {
          willReadFrequently: true
        });

        const pixels = context.getImageData(
          0,
          0,
          canvas.width,
          canvas.height
        ).data;

        let transparent = 0;
        let sampled = 0;

        for (
          let index = 3;
          index < pixels.length;
          index += 64
        ) {
          sampled += 1;

          if (pixels[index] < 40) {
            transparent += 1;
          }
        }

        return (
          sampled > 0 &&
          transparent / sampled >= 0.42
        );
      };

      const finishScratch = () => {
        if (scratched) return;

        scratched = true;

        canvas.style.transition = 'opacity 220ms ease';
        canvas.style.opacity = '0';
        canvas.style.pointerEvents = 'none';

        hint.hidden = true;
        revealButton.hidden = true;
        gate.hidden = false;

        window.setTimeout(() => {
          emailInput.focus();
        }, 250);
      };

      const scratch = (event) => {
        if (!drawing || scratched) return;

        event.preventDefault();

        const point = pointFromEvent(event);

        const context = canvas.getContext('2d', {
          willReadFrequently: true
        });

        context.beginPath();

        if (lastPoint) {
          context.moveTo(lastPoint.x, lastPoint.y);
          context.lineTo(point.x, point.y);
        } else {
          context.moveTo(point.x, point.y);
          context.lineTo(
            point.x + 0.1,
            point.y + 0.1
          );
        }

        context.stroke();
        lastPoint = point;
      };

      canvas.addEventListener('pointerdown', (event) => {
        drawing = true;
        lastPoint = null;

        canvas.setPointerCapture(event.pointerId);
        scratch(event);
      });

      canvas.addEventListener('pointermove', scratch);

      canvas.addEventListener('pointerup', () => {
        drawing = false;
        lastPoint = null;

        if (scratchedEnough()) {
          finishScratch();
        }
      });

      canvas.addEventListener('pointercancel', () => {
        drawing = false;
        lastPoint = null;
      });

      revealButton.addEventListener(
        'click',
        finishScratch
      );

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        error.hidden = true;

        if (!form.reportValidity()) return;

        if (!publicKey || !listId || !discountCode) {
          error.textContent =
            dialog.dataset.unavailableMessage;

          error.hidden = false;
          return;
        }

        const email = emailInput.value
          .trim()
          .toLowerCase();

        submitButton.disabled = true;

        try {
          await subscribe(email);
          identifyAndTrack(email);

          claimed = true;

          codeElement.textContent = discountCode;

          shopLink.href =
            `/discount/${encodeURIComponent(discountCode)}` +
            `?redirect=${encodeURIComponent(shopPath)}`;

          gate.hidden = true;
          result.hidden = false;

          writeState({
            claimedAt: Date.now(),
            email
          });
        } catch (_error) {
          error.textContent =
            dialog.dataset.errorMessage;

          error.hidden = false;
        } finally {
          submitButton.disabled = false;
        }
      });

      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(
            discountCode
          );

          copyButton.textContent =
            dialog.dataset.copiedLabel;
        } catch (_error) {
          window.prompt(
            'Copy your discount code:',
            discountCode
          );
        }
      });

      window.addEventListener('resize', () => {
        if (dialog.open && !scratched) {
          paintCanvas();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
